import { render, staticRenderFns } from "./motivoRechazoPti.vue?vue&type=template&id=657c95f2"
import script from "./motivoRechazoPti.vue?vue&type=script&lang=js"
export * from "./motivoRechazoPti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports